import styled, { css } from 'styled-components'
import QuotePNG from 'assets/quote.png'

export const Container = styled.section`
  width: 100%;
  padding: 80px 15%;
  background: ${({ theme }) => theme.colors.orangeBackground};
  position: relative;
  @media screen and (max-width: 1024px) {
    padding: 80px 5%;
  }
`

export const Content = styled.div`
  width: 100%;
  margin-top: 32px;
`

export const Item = styled.div`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  width: 95% !important;
  @media screen and (max-width: 768px) {
    width: 100% !important;
  }
`

const descriptionTypography = css`
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme }) => theme.colors.white};
  width: fit-content;
`

export const ItemAuthor = styled.p`
  ${descriptionTypography};
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
`

export const ItemAuthorRole = styled.p`
  ${descriptionTypography};
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
`

export const ItemDescription = styled.div`
  margin-top: 30px;
  @media screen and (max-width: 768px) {
    margin-top: 15px;
  }
`

export const ItemCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 32px;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 220px;
  @media screen and (max-width: 768px) {
    padding: 16px;
    min-height: 200px;
  }
`

export const ItemCardDialog = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.white};
  width: 18px;
  height: 18px;
  transform: rotate(45deg);
  align-self: center;
  bottom: -8px;
`

const typography = css`
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme }) => theme.colors.black};
`

export const ItemText = styled.p`
  ${typography};
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
`

export const ItemTitle = styled.h3`
  ${typography};
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  margin-bottom: 8px;
`

export const Quote = styled.div`
  position: absolute;
  top: 68px;
  z-index: 0;
  right: 12.5%;
  background: url(${QuotePNG});
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.5;
  width: 149px;
  height: 149px;
`
